import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getLocalJSON } from '../../../_helpers/storage.util';

@Component({
  selector: 'profile-top-outer',
  templateUrl: './profile-top-outer.component.html',
  styleUrls: ['./profile-top-outer.component.scss'],
})
export class ProfileTopOuterComponent {
  @Input() currentDetail: any = {};
  @Input() imgURL: any = '';
  /** When true, shows upload controls instead of the edit-profile link. */
  @Input() editable = false;
  /** Structured creator types from the profile API (`_id`, `name`). */
  @Input() creatorTypes: any[] = [];
  /** Optional override for the banner background colour. */
  @Input() backgroundColor = '';

  @Output() uploadClick = new EventEmitter<void>();

  get displayName(): string {
    if (this.currentDetail?.user_role_type == 2 && this.currentDetail?.org_name) {
      return this.currentDetail.org_name;
    }
    return `${this.currentDetail?.firstName || ''} ${this.currentDetail?.lastName || ''}`.trim();
  }

  get creatorTypeLabel(): string {
    const types = this.creatorTypes?.length
      ? this.creatorTypes
      : (this.currentDetail?.creator_types || []);
    return types
      .map((item: any) => item?.name)
      .filter((name: string) => !!name)
      .join(', ');
  }

  get bannerColor(): string {
    if (this.backgroundColor) {
      return this.backgroundColor;
    }
    const pillarId = this.currentDetail?.primary_pillar;
    if (!pillarId) {
      return '#808080';
    }
    const masterData = getLocalJSON<any>('grw_materData', {});
    const pillars = masterData?.primary_pillars || [];
    const match = pillars.find((pillar: any) => String(pillar._id) === String(pillarId));
    return match?.color || '#808080';
  }

  onUploadClick(): void {
    this.uploadClick.emit();
  }
}
